import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const MobileAdV5HeroSection = () => {
  const [messagesToShow, setMessagesToShow] = useState(0);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setMessagesToShow(prev => {
        if (prev < 7) return prev + 1;
        clearInterval(timer);
        return prev;
      });
    }, 1500); // 1.5 seconds between each message
    
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messagesToShow]);

  // Time for top bar
  const [time, setTime] = useState('9:41');
  useEffect(() => {
    const date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    setTime(`${hours}:${minutes}`);
  }, []);

  return (
    <div className="flex flex-col h-screen bg-white font-sans text-black overflow-hidden relative w-full">
      {/* iOS Status Bar */}
      <div className="flex justify-between items-center px-6 py-3 text-sm font-semibold relative z-10 bg-white/80 backdrop-blur-md">
        <span>{time}</span>
        <div className="flex gap-1.5 items-center">
          {/* Signal bars */}
          <div className="flex gap-0.5 items-end h-2.5">
            <div className="w-0.5 h-1.5 bg-black rounded-sm"></div>
            <div className="w-0.5 h-2 bg-black rounded-sm"></div>
            <div className="w-0.5 h-2.5 bg-black rounded-sm"></div>
            <div className="w-0.5 h-3 bg-black rounded-sm"></div>
          </div>
          {/* Wifi */}
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinelinejoin="round">
            <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
            <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
            <line x1="12" y1="20" x2="12.01" y2="20"></line>
          </svg>
          {/* Battery */}
          <div className="w-6 h-3 rounded-[4px] border border-black p-[1px] relative">
            <div className="w-[80%] h-full bg-black rounded-[2px]"></div>
            <div className="absolute -right-1 top-1/2 -translate-y-1/2 w-0.5 h-1 bg-black rounded-r-sm"></div>
          </div>
        </div>
      </div>

      {/* iOS Header */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-white/90 backdrop-blur-md relative z-10 pb-4">
        <div className="flex items-center text-blue-500 text-lg">
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-200 text-gray-500 ml-1">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 rounded-full bg-gradient-to-tr from-gray-200 to-gray-300 flex items-center justify-center mb-0.5 shadow-sm text-2xl font-bold text-white">
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <span className="text-xs font-semibold text-gray-800">+1 (310) 555-0198</span>
        </div>
        <div className="text-blue-500 w-12 flex justify-end">
          {/* Empty spacer to balance layout */}
        </div>
      </div>

      {/* Chat Area */}
      <div className="flex-1 overflow-y-auto px-4 py-6 bg-white space-y-5">
        
        {/* Time separator */}
        <div className="text-center text-xs text-gray-400 font-medium mb-6">Today {time}</div>

        {/* Message 1: Received */}
        <motion.div 
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: messagesToShow > 0 ? 1 : 0, y: messagesToShow > 0 ? 0 : 10, scale: messagesToShow > 0 ? 1 : 0.95 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-start"
        >
          <div className="bg-[#E9E9EB] text-black px-4 py-2.5 rounded-2xl rounded-bl-sm max-w-[75%] text-[17px] leading-tight">
            My feed has so many dental AI ads but none of this crap works
          </div>
        </motion.div>

        {/* Message 2: Sent */}
        <motion.div 
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: messagesToShow > 1 ? 1 : 0, y: messagesToShow > 1 ? 0 : 10, scale: messagesToShow > 1 ? 1 : 0.95 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-end"
        >
          <div className="bg-[#0A84FF] text-white px-4 py-2.5 rounded-2xl rounded-br-sm max-w-[75%] text-[17px] leading-tight">
            Yeah because they're all separate tools that don't speak to eachother. Have you tried Asha?
          </div>
        </motion.div>

        {/* Message 3: Received */}
        <motion.div 
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: messagesToShow > 2 ? 1 : 0, y: messagesToShow > 2 ? 0 : 10, scale: messagesToShow > 2 ? 1 : 0.95 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-start"
        >
          <div className="bg-[#E9E9EB] text-black px-4 py-2.5 rounded-2xl rounded-bl-sm max-w-[75%] text-[17px] leading-tight">
            what's that?
          </div>
        </motion.div>

        {/* Message 4: Sent - Normal Text */}
        <motion.div 
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: messagesToShow > 3 ? 1 : 0, y: messagesToShow > 3 ? 0 : 10, scale: messagesToShow > 3 ? 1 : 0.95 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-end"
        >
          <div className="bg-[#0A84FF] text-white px-4 py-2.5 rounded-2xl rounded-br-sm max-w-[75%] text-[17px] leading-tight">
            A new type of PMS, with 20 dental AI products in 1 platform. It can literally run your office without any staff.
          </div>
        </motion.div>

        {/* Message 5: Received */}
        <motion.div 
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: messagesToShow > 4 ? 1 : 0, y: messagesToShow > 4 ? 0 : 10, scale: messagesToShow > 4 ? 1 : 0.95 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-start"
        >
          <div className="bg-[#E9E9EB] text-black px-4 py-2.5 rounded-2xl rounded-bl-sm max-w-[75%] text-[17px] leading-tight">
            That's BS, I don't believe you.
          </div>
        </motion.div>

        {/* Message 6: Sent */}
        <motion.div 
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: messagesToShow > 5 ? 1 : 0, y: messagesToShow > 5 ? 0 : 10, scale: messagesToShow > 5 ? 1 : 0.95 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-end"
        >
          <div className="bg-[#0A84FF] text-white px-4 py-2.5 rounded-2xl rounded-br-sm max-w-[75%] text-[17px] leading-tight">
            See for yourself
          </div>
        </motion.div>

        {/* Message 7: Sent - Rich Text Link */}
        <motion.div 
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: messagesToShow > 6 ? 1 : 0, y: messagesToShow > 6 ? 0 : 10, scale: messagesToShow > 6 ? 1 : 0.95 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-end"
        >
          <div className="w-[280px] rounded-2xl overflow-hidden bg-[#E9E9EB]/60 border border-gray-200/50 relative cursor-pointer active:scale-[0.98] transition-transform">
            <div className="h-[140px] bg-[#0A84FF] flex items-center justify-center relative overflow-hidden">
               {/* Background effect */}
               <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-[#0A84FF] opacity-90" />
               <div className="absolute -inset-4 bg-white/20 blur-2xl rounded-full mix-blend-overlay" />
               
               {/* Logo and branding */}
               <div className="relative z-10 flex flex-col items-center justify-center text-center px-6">
                 <div className="text-white font-bold tracking-tight text-2xl drop-shadow-md leading-tight">
                   20 dental AI products in 1 platform
                 </div>
               </div>
            </div>
            <div className="p-3 bg-[#E9E9EB]">
              <div className="font-semibold text-black text-[15px] mb-1">Asha Health</div>
              <div className="text-gray-500 text-[13px] leading-snug line-clamp-2">20 dental AI products in 1 platform. The world's first and only AI-native PMS.</div>
              <div className="text-gray-400 text-[11px] mt-1.5 uppercase tracking-wide">asha.health</div>
            </div>
          </div>
        </motion.div>

        {/* Typing indicator (only shows before the other person replies) */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: (messagesToShow === 0 || messagesToShow === 2 || messagesToShow === 4) ? 1 : 0 }}
          className="flex flex-col items-start"
        >
          <div className="bg-[#E9E9EB] text-black px-4 py-3 rounded-2xl rounded-bl-sm max-w-[75%] w-16 h-9 relative">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex gap-1">
              <motion.div className="w-1.5 h-1.5 bg-gray-400 rounded-full" animate={{ y: [0, -3, 0] }} transition={{ repeat: Infinity, duration: 1, delay: 0 }} />
              <motion.div className="w-1.5 h-1.5 bg-gray-400 rounded-full" animate={{ y: [0, -3, 0] }} transition={{ repeat: Infinity, duration: 1, delay: 0.2 }} />
              <motion.div className="w-1.5 h-1.5 bg-gray-400 rounded-full" animate={{ y: [0, -3, 0] }} transition={{ repeat: Infinity, duration: 1, delay: 0.4 }} />
            </div>
          </div>
        </motion.div>
        
        {/* Invisible div to scroll to */}
        <div ref={messagesEndRef} />
        
      </div>

      {/* Input area */}
      <div className="px-4 py-3 border-t border-gray-200 bg-gray-50">
        <div className="flex items-center gap-3">
          <svg className="w-6 h-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4v16m8-8H4" />
          </svg>
          <div className="flex-1 bg-white border border-gray-300 rounded-full px-4 py-1.5 flex items-center justify-between text-[15px] text-gray-400">
            <span>iMessage</span>
            <svg className="w-5 h-5 text-[#0A84FF]" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
              <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
            </svg>
          </div>
        </div>
      </div>
      
      {/* Home indicator */}
      <div className="h-1.5 w-1/3 bg-black rounded-full mx-auto my-1.5 opacity-80" />
    </div>
  );
};

export default MobileAdV5HeroSection;